import React, { ChangeEvent, forwardRef, useCallback } from 'react';

import { SelectInput } from './styled';
import { withLabels } from '../../hoc';

export type SelectOption = {
  label: string;
  value: string;
  disabled?: boolean;
  hidden?: boolean;
};

export interface SelectProps
  extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size' | 'onChange'> {
  id?: string;
  className?: string;
  options: Array<SelectOption>;
  value?: string;
  size?: 'sm' | 'base';
  disabled?: boolean;
  hasError?: boolean;
  onChange?: (value: string) => void;
}

export const Select = withLabels(
  forwardRef<HTMLSelectElement, SelectProps>(
    (
      { className, options, value, onChange, size, disabled, hasError, ...otherProps }: SelectProps,
      ref,
    ) => {
      const handleChange = useCallback(
        (e: ChangeEvent<HTMLSelectElement>) => {
          if (!onChange) return;
          onChange(e.currentTarget.value);
        },
        [onChange],
      );

      return (
        <SelectInput
          className={className}
          sizeVariant={size}
          value={value ?? undefined}
          onChange={handleChange}
          disabled={disabled}
          hasError={hasError}
          ref={ref}
          {...otherProps}
        >
          {!!options &&
            options.map((option) => (
              <option
                key={option.label}
                value={option.value}
                disabled={option.disabled}
                hidden={option.hidden}
              >
                {option.label}
              </option>
            ))}
        </SelectInput>
      );
    },
  ),
);

Select.displayName = 'Select';
